import {OnlineCheckInBlockerSsr} from "../online-check-in-blocker-ssr";

export abstract class UnaccompaniedMinorBaseSsr extends OnlineCheckInBlockerSsr {

}
